import {
  createStyles,
  Title,
  Text,
  Space,
  Anchor,
  Image,
  Box,
  Divider,
} from '@mantine/core';
import { Carousel } from '@mantine/carousel';
import { themeColors } from '../../config/themeSettings';

const galleryImages = [
  'https://static.businessworld.in/IMG_20251213_130258_20251213172204_original_image_14.webp',
  'https://static.businessworld.in/IMG_20251213_130906_20251213172251_original_image_38.webp',
];

const IndiaAutoRickshawRally = () => {
  const { classes } = useStyles();

  return (
    <div>
      <div className={classes.dateCategory}>
        December 13, 2025 | India News
      </div>
      <section className={classes.header}>
        <Title order={1} className={classes.title}>
          SAYHELP App reaches masses, Nirbhaya's mother flags off over 500 auto rickshaws in a rally
        </Title>
      </section>
      <div className={classes.container}>
        <Box className={classes.sectionCenter}>
          <Box className={classes.carouselContainer}>
            <Carousel
              withIndicators
              height={600}
              slideSize="100%"
              slideGap="md"
              loop
              align="center"
              className={classes.carousel}>
              {galleryImages.map((image, index) => (
                <Carousel.Slide key={index}>
                  <Image
                    src={image}
                    alt={`Say Help Auto Rickshaw Rally ${index + 1}`}
                    height={600}
                    fit="cover"
                  />
                </Carousel.Slide>
              ))}
            </Carousel>
          </Box>
          <div className={classes.imageAttribution}>
            Images from BW Police World
          </div>

          <Space h="xl" />

          <section className={classes.paragraph}>
            <Space h="md" />
            <Text>
              <strong>New Delhi, December 13</strong>
            </Text>
            <Space h="md" />
            <Text>
              Say Help app in collaboration with community stakeholders, organised a large-scale public awareness programme on women safety and emergency response through the SAYHELP mobile application, a voice-activated and SOS-button-enabled safety app, aimed at strengthening rapid assistance for women and vulnerable citizens.
            </Text>
            <Space h="md" />
            <Text>
              As part of the initiative, around 500 auto-rickshaws were mobilised and fitted with SAYHELP awareness banners on their hoods to enhance visibility and outreach across public spaces and high-footfall areas of the Central District.
            </Text>
            <Space h="md" />
            <Text>
              The auto-rickshaw awareness rally was formally flagged off by Nirbhaya's mother Asha Devi, whose presence added moral strength and social relevance to the programme.
            </Text>
            <Space h="md" />
            <Text>
              The event was held in the esteemed presence of Robin Hibu, Special Commissioner of Police (HRD), Delhi Police, who encouraged community participation and the use of technology-driven solutions for public safety.
            </Text>
            <Space h="md" />
            <Text>
              Addressing the gathering, Asha Devi emphasised the importance of collective responsibility, awareness, and timely use of safety tools to prevent crimes against women.
            </Text>
            <Space h="md" />
            <Text>
              Special CP HRD, Robin Hibu highlighted Delhi Police's continued commitment towards Smart Policing, community engagement, and technology-based citizen safety initiatives, in alignment with national policing priorities.
            </Text>
            <Space h="md" />
            <Text>
              The SAYHELP app enables users to send instant distress alerts through voice command or a single-touch SOS button, ensuring quick response and assistance during emergencies. The auto-rickshaw outreach campaign is expected to significantly increase public awareness and adoption of the app.
            </Text>
            <Space h="md" />
          </section>

          <Space h="xl" />

          <Box
            style={{
              position: 'relative',
              paddingBottom: '56.25%',
              height: 0,
              overflow: 'hidden',
              maxWidth: '100%',
            }}>
            <iframe
              style={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
              }}
              src="https://www.youtube.com/embed/Er9R8tLJJyc"
              title="Say Help Auto Rickshaw Rally"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
          </Box>

          <Space h="xl" />

          <Divider></Divider>
          <Text className={classes.footNote}>
            Story by{' '}
            <Anchor
              href="https://www.bwpoliceworld.com/article/sayhelp-app-reaches-maases-nirbhaya-s-mother-flags-off-over-500-auto-rickshaws-in-a-rally-583560"
              target="_blank">
              BW Online Bureau
            </Anchor>
            . Source:{' '}
            <Anchor
              href="https://www.bwpoliceworld.com/article/sayhelp-app-reaches-maases-nirbhaya-s-mother-flags-off-over-500-auto-rickshaws-in-a-rally-583560"
              target="_blank">
              BW Police World
            </Anchor>
          </Text>
        </Box>
      </div>
    </div>
  );
};

export default IndiaAutoRickshawRally;

const useStyles = createStyles(theme => ({
  root: {
    fontFamily: 'Poppins',
    backgroundColor: themeColors.white,
    height: '100%',
    width: '100%',
    overflowX: 'hidden',
  },

  dateCategory: {
    fontSize: 14,
    fontWeight: 'normal',
    marginBottom: 10,
    textAlign: 'center',
    color: '#757575',
  },

  container: {
    paddingLeft: 20,
    paddingRight: 20,
    paddingTop: 20,
  },

  header: {
    textAlign: 'center',
    display: 'grid',
    gridTemplateColumns: 'minmax(min-content, 900px)',
    gridTemplateRows: 'auto',
    justifyContent: 'center',
    justifyItems: 'center',
    gap: 20,
  },

  carouselContainer: {
    width: '100%',
    marginTop: 20,
  },

  carousel: {
    '& .mantine-Carousel-indicator': {
      backgroundColor: 'rgba(0, 0, 0, 0.3)',
      '&[data-active]': {
        backgroundColor: themeColors.anchor,
      },
    },
  },

  footNote: {
    fontSize: 12,
    marginTop: 20,
    color: '#757575',
  },

  imageAttribution: {
    fontSize: 12,
    marginTop: 10,
    color: '#757575',
    textAlign: 'center',
  },

  title: {
    fontFamily: 'Poppins',
    fontWeight: 'bold',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: 'normal',
    letterSpacing: 'normal',
    textAlign: 'center',
    color: themeColors.anchor,
  },

  paragraph: {
    fontFamily: 'Poppins',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: 'normal',
    letterSpacing: 'normal',
    color: themeColors.anchor,
  },

  sectionCenter: {
    marginLeft: 'auto',
    marginRight: 'auto',
    width: '90vw',
    maxWidth: 900,
  },
}));
